import React from 'react'
import { ButtonProps, useDisclosure } from '@chakra-ui/react'

import ClientSearchModal from './search-modal'
import { OnSelectArgs, SearchModalType } from './types'
import ClientSearchTriggerButton from './trigger-button'

interface Props {
    customTrigger?: (onClick: () => void) => React.ReactNode
    buttonOverrides?: ButtonProps
    labelOverride?: string
    type?: SearchModalType
    showReminderPdfAction?: boolean
    onSelect: (args: OnSelectArgs) => void
}

export default function ClientsPatientsSearch({
    onSelect,
    labelOverride,
    buttonOverrides,
    customTrigger,
    type = SearchModalType.Client,
    showReminderPdfAction = type === SearchModalType.Patient,
}: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            {customTrigger ? (
                customTrigger(onOpen)
            ) : (
                <ClientSearchTriggerButton
                    onClick={onOpen}
                    labelOverride={labelOverride}
                />
            )}
            <ClientSearchModal
                isOpen={isOpen}
                onClose={onClose}
                onSelect={onSelect}
                type={type}
                showReminderPdfAction={showReminderPdfAction}
            />
        </>
    )
}
